export default __webpack_public_path__ + "static/media/fantasyLottoLogo.4e3cc5bd.png";